import { render } from "./Biometrics.vue?vue&type=template&id=6a85d3fa&scoped=true"
import script from "./Biometrics.vue?vue&type=script&lang=js"
export * from "./Biometrics.vue?vue&type=script&lang=js"

import "./Biometrics.vue?vue&type=style&index=0&id=6a85d3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a85d3fa"]])

export default __exports__